/*
 * Resource Download — gated form modal (Part 2).
 *
 * Behaviour for sections/resource-download-form.liquid:
 *  - Open from any link whose href is "#<modal id>" (default "#download-report");
 *    close via the X, the overlay, or ESC. Focus trap + body scroll lock + return
 *    focus to the opener. prefers-reduced-motion is handled in CSS.
 *  - "How did you hear about us?" reveals a conditional "Other" free-text field
 *    (required only while visible).
 *  - Submit goes straight to the Mailchimp audience via JSONP (no backend, so it
 *    bypasses the store's Cloudflare and carries every field as a merge field).
 *    On success we show the thank-you state and open the report file.
 *  - If no Mailchimp action URL is configured the network call is skipped and we
 *    go straight to the thank-you state (demo mode), so the journey is reviewable
 *    before the client's audience exists.
 */
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init() {
    var modals = document.querySelectorAll('[data-resource-form]');
    if (!modals.length) return;

    modals.forEach(setupModal);
  }

  function setupModal(modal) {
    if (modal.dataset.bound === '1') return;
    modal.dataset.bound = '1';

    var panel = modal.querySelector('.resource-form__panel');
    var form = modal.querySelector('[data-resource-form-form]');
    var select = modal.querySelector('[data-resource-form-field="source"]');
    var otherWrap = modal.querySelector('[data-resource-form-other]');
    var otherInput = otherWrap
      ? otherWrap.querySelector('[data-resource-form-field="source_other"]')
      : null;
    var errorBox = modal.querySelector('[data-resource-form-error]');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    var submitLabel = submitBtn ? submitBtn.textContent : '';
    var opener = null;

    // --- open / close -------------------------------------------------------
    function open(trigger) {
      opener = trigger || document.activeElement;
      modal.hidden = false;
      modal.removeAttribute('aria-hidden');
      // Force reflow so the .is-open transition runs from the hidden state.
      void modal.offsetWidth;
      modal.classList.add('is-open');
      lockScroll();
      var first = form && form.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function close() {
      modal.classList.remove('is-open');
      unlockScroll();
      var done = function () {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        panel.removeEventListener('transitionend', done);
        resetToForm();
        if (opener && typeof opener.focus === 'function') opener.focus();
        opener = null;
      };
      // Wait for the panel transition, but fall back if it doesn't fire
      // (reduced-motion / display quirks).
      if (prefersReducedMotion()) {
        done();
      } else {
        panel.addEventListener('transitionend', done);
        setTimeout(function () {
          if (!modal.hidden) done();
        }, 450);
      }
    }

    function resetToForm() {
      showView('form');
      if (form) form.reset();
      clearErrors();
      toggleOther();
    }

    // --- focus trap + keyboard ---------------------------------------------
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusables = Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        }
      );
      if (!focusables.length) return;
      var firstEl = focusables[0];
      var lastEl = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      } else if (!e.shiftKey && document.activeElement === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    });

    modal.querySelectorAll('[data-resource-form-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    // --- triggers (delegated, so CTAs rendered anywhere work) --------------
    var id = modal.id;
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var trigger = e.target.closest(
        'a[href="#' + id + '"], [data-resource-download-trigger="' + id + '"]'
      );
      if (!trigger) return;
      if (modal.contains(trigger)) return; // ignore links inside the modal itself
      e.preventDefault();
      open(trigger);
    });

    // --- conditional "Other" -----------------------------------------------
    function toggleOther() {
      if (!select || !otherWrap) return;
      var isOther =
        select.value &&
        select.value === (modal.dataset.otherValue || 'Other');
      otherWrap.hidden = !isOther;
      if (otherInput) {
        if (isOther) {
          otherInput.setAttribute('required', '');
        } else {
          otherInput.removeAttribute('required');
          otherInput.value = '';
        }
      }
    }
    if (select) select.addEventListener('change', function () {
      toggleOther();
      // a chosen option turns the select from its "invalid" placeholder colour
      select.closest('.resource-form__field').classList.remove('is-invalid');
    });

    // --- validation ---------------------------------------------------------
    function fieldEls() {
      return Array.prototype.slice.call(
        form.querySelectorAll('[data-resource-form-field]')
      );
    }

    function clearErrors() {
      if (errorBox) {
        errorBox.hidden = true;
        errorBox.textContent = '';
      }
      modal.querySelectorAll('.resource-form__field.is-invalid').forEach(function (f) {
        f.classList.remove('is-invalid');
      });
    }

    function markInvalid(el) {
      var field = el.closest('.resource-form__field');
      if (field) field.classList.add('is-invalid');
    }

    function validate() {
      clearErrors();
      var firstBad = null;
      fieldEls().forEach(function (el) {
        if (el === otherInput && otherWrap.hidden) return; // skip hidden Other
        var val = (el.value || '').trim();
        var bad = false;
        if (el.hasAttribute('required') && !val) bad = true;
        if (el.type === 'email' && val && !EMAIL_RE.test(val)) bad = true;
        if (bad) {
          markInvalid(el);
          if (!firstBad) firstBad = el;
        }
      });
      if (firstBad) {
        showError('Please complete the highlighted fields.');
        firstBad.focus();
        return false;
      }
      return true;
    }

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.hidden = false;
    }

    // --- views --------------------------------------------------------------
    function showView(name) {
      modal.querySelectorAll('[data-resource-form-view]').forEach(function (v) {
        v.hidden = v.getAttribute('data-resource-form-view') !== name;
      });
    }

    function onSuccess() {
      showView('thanks');
      openFile(modal.dataset.file);
    }

    // --- submit -------------------------------------------------------------
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Honeypot: a real user never fills this.
        var hp = form.querySelector('[data-resource-form-hp]');
        if (hp && hp.value) {
          onSuccess(); // silently pretend success for bots
          return;
        }

        if (!validate()) return;
        if (form.dataset.submitting === '1') return;

        var action = (modal.dataset.action || '').trim();
        var payload = collectPayload(modal, form);

        // Demo mode: no Mailchimp configured yet.
        if (!action) {
          onSuccess();
          return;
        }

        setSubmitting(true);
        mailchimpJsonp(action, payload, function (res) {
          setSubmitting(false);
          if (res && res.result === 'success') {
            onSuccess();
          } else {
            showError(cleanMailchimpMsg(res && res.msg) || 'Something went wrong. Please try again.');
          }
        });
      });
    }

    function setSubmitting(on) {
      if (!submitBtn) return;
      if (on) {
        form.dataset.submitting = '1';
        form.setAttribute('aria-busy', 'true');
        submitBtn.querySelector('span').textContent = 'Sending…';
      } else {
        delete form.dataset.submitting;
        form.removeAttribute('aria-busy');
        submitBtn.querySelector('span').textContent = submitLabel.trim() || 'Submit';
      }
    }

    // expose open() for programmatic use if ever needed
    modal.resourceFormOpen = open;
    resetToForm();
  }

  // --- helpers --------------------------------------------------------------
  function collectPayload(modal, form) {
    function val(name) {
      var el = form.querySelector('[data-resource-form-field="' + name + '"]');
      return el ? (el.value || '').trim() : '';
    }
    var map = {};
    var tagEmail = modal.dataset.tagEmail || 'EMAIL';
    map[tagEmail] = val('email');
    addTag(map, modal.dataset.tagName, val('name'));
    addTag(map, modal.dataset.tagPhone, val('phone'));
    addTag(map, modal.dataset.tagSource, val('source'));
    addTag(map, modal.dataset.tagSourceOther, val('source_other'));
    return map;
  }

  function addTag(map, tag, value) {
    tag = (tag || '').trim();
    if (tag && value) map[tag] = value;
  }

  // Mailchimp hosted endpoint accepts JSONP at /subscribe/post-json with &c=cb.
  function mailchimpJsonp(action, params, callback) {
    // Mailchimp's JSONP endpoint is /subscribe/post-json. Normalise whether the
    // configured action URL is /post or already /post-json (a naive double
    // replace turns /post into /post-json-json -> 404).
    var url = action.indexOf('/post-json') !== -1
      ? action
      : action.replace('/post', '/post-json');
    // Drop f_id: it scopes the submit to one embedded form, and Mailchimp then
    // ignores any merge field not enabled on that form (only EMAIL saves).
    // Removing it reverts to the audience subscribe, which accepts all fields.
    url = url
      .replace(/[?&]f_id=[^&]*/i, function (m) { return m.charAt(0) === '?' ? '?' : ''; })
      .replace(/\?&/, '?');
    // Mailchimp's anti-bot field: b_<u>_<id>, must be present and empty.
    var u = getQueryParam(action, 'u');
    var id = getQueryParam(action, 'id');
    var query = [];
    Object.keys(params).forEach(function (k) {
      query.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
    });
    if (u && id) query.push('b_' + u + '_' + id + '=');

    var cbName = 'rdfMc_' + Date.now() + '_' + Math.floor(Math.random() * 1e6);
    var script = document.createElement('script');
    var timer = setTimeout(function () {
      cleanup();
      callback({ result: 'error', msg: 'Network timeout' });
    }, 12000);

    function cleanup() {
      clearTimeout(timer);
      try {
        delete window[cbName];
      } catch (e) {
        window[cbName] = undefined;
      }
      if (script.parentNode) script.parentNode.removeChild(script);
    }

    window[cbName] = function (res) {
      cleanup();
      callback(res);
    };

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    script.src = url + sep + query.join('&') + '&c=' + cbName;
    script.onerror = function () {
      cleanup();
      callback({ result: 'error', msg: 'Network error' });
    };
    document.body.appendChild(script);
  }

  function getQueryParam(url, key) {
    var m = url.match(new RegExp('[?&]' + key + '=([^&]+)'));
    return m ? m[1] : '';
  }

  // Mailchimp errors arrive as HTML-ish strings, sometimes prefixed "0 - ".
  function cleanMailchimpMsg(msg) {
    if (!msg) return '';
    return String(msg).replace(/^\d+\s*-\s*/, '').replace(/<[^>]*>/g, '').trim();
  }

  function openFile(url) {
    url = (url || '').trim();
    if (!url) return;
    var a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  var scrollLockCount = 0;
  var savedOverflow = '';
  function lockScroll() {
    if (scrollLockCount === 0) {
      savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    scrollLockCount++;
  }
  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.body.style.overflow = savedOverflow;
    }
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
